'use strict';

var $ = require('jquery');

var login;

/**
 * @private
 * @function
 * @description init events for the loginPage
 */
function initLoginPage() {
    //o-auth binding for which icon is clicked
    $('.oAuthIcon').bind('click', function () {
        $('#OAuthProvider').val(this.id);
    });

    //toggle the value of the rememberme checkbox
    $('#dwfrm_login_rememberme').bind('change', function () {
        if ($('#dwfrm_login_rememberme').attr('checked')) {
            $('#rememberme').val('true');
        } else {
            $('#rememberme').val('false');
        }
    });

    //Login Rebrush - expand register form
    $('#open-register-form').click(function (e) {
        e.preventDefault();

        $(this).slideUp();

        $('.register-wrapper').slideDown();
        $(this).attr('aria-expanded', 'true');
        $('#register-wrapper').focus();
    });

    //Login - prevent double click
    let formSubmitted = false;
    $('#dwfrm_login').on('submit', function (e) {
        if (formSubmitted) {
            e.preventDefault();
            return false;
        }

        // Check if the form is valid
        if (!this.checkValidity()) {
            return true; // Let the browser handle the invalid form
        }

        formSubmitted = true;

        // Disable all submit buttons to prevent double-click in a separate thread to allow proper submission
        setTimeout(function () {
            $('.js-login-submit-btn').each(function () {
                $(this).attr('disabled', 'true');
            });
        }, 0);

        return true;
    });
}

login = {
    init: function () {
        initLoginPage();
    },
    initCartLogin: function () {
        initLoginPage();
    }
};

module.exports = login;
